import React, { useState } from 'react'

function userInitials(name) {
  return (String(name ?? '').trim() || '?')
    .split(/\s+/)
    .map((word) => word[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()
}

// Round profile photo, or the user's initials on the brand colour when there is no photo
// (or it fails to load).
export default function UserAvatar({ url, name, size = 36, className = '' }) {
  const [failedUrl, setFailedUrl] = useState(null)
  const showImage = Boolean(url) && failedUrl !== url
  const style = { width: size, height: size, fontSize: Math.max(11, Math.round(size * 0.38)) }
  if (showImage) {
    return <img src={url} alt="" style={style} className={`shrink-0 rounded-full object-cover ${className}`} onError={() => setFailedUrl(url)} />
  }
  return (
    <div style={style} aria-hidden="true" className={`flex shrink-0 select-none items-center justify-center rounded-full bg-primary font-bold text-white ${className}`}>
      {userInitials(name)}
    </div>
  )
}
